import { createCommands } from 'utils/commands';

export const editorCopilotDropdownCommands = createCommands([
  {
    group: 'richTextEditor',
    label: 'Improve reply',
    name: 'improveReply',
    description: 'Opens the Improve reply modal',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl', 'Shift'], 'KeyP'] }],
    },
  },
  {
    group: 'richTextEditor',
    label: 'Match to style guide',
    name: 'matchToStyleGuide',
    description:
      'Improves the selected text in the editor to match the applicable style guide',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl', 'Shift'], 'KeyY'] }],
    },
  },
  {
    group: 'richTextEditor',
    label: 'Quick translate',
    name: 'translateToConversationLanguage',
    description:
      'Translates the selected text in the editor to the language of the conversation',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl', 'Shift'], 'KeyT'] }],
    },
  },
  {
    group: 'richTextEditor',
    label: 'Custom translate',
    name: 'translate',
    description: 'Translates the selected text in the editor',
  },
  {
    group: 'richTextEditor',
    label: 'Check spelling and grammar',
    name: 'checkSpellingAndGrammar',
    description:
      'Checks the spelling and grammar of selected text in the editor',
    keyboard: {
      keybindings: [{ binding: [[], 'F7'] }],
    },
  },
  {
    group: 'richTextEditor',
    label: 'Expand reply',
    name: 'expandText',
    description:
      'Enriches the selected text in the editor to provide more context',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl', 'Shift'], 'KeyX'] }],
    },
  },
  {
    group: 'richTextEditor',
    label: 'Custom Mim drafts',
    name: 'customAiDraft',
    description:
      'Generates a reply draft for the conversation using an AI agent',
    featureFlag: 'mim-drafts',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl', 'Shift'], 'KeyD'] }],
    },
  },
  {
    group: 'richTextEditor',
    label: 'Quick Mim drafts',
    name: 'quickAiDraft',
    description:
      'Drafts a reply with the default AI agent and inserts it into the editor',
    featureFlag: 'mim-drafts',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl', 'Shift'], 'KeyG'] }],
    },
  },
]);
